import _defineProperty from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import * as tslib_1 from "tslib";
import { array, isArray } from 'vega-util';
import { isSingleDefUnitChannel } from '../../../channel';
import * as log from '../../../log';
import { hasContinuousDomain } from '../../../scale';
import { isIntervalSelection } from '../../../selection';
import { hash, keys, varName } from '../../../util';
import { TimeUnitNode } from '../../data/timeunit';
import scales from './scales';
export var TUPLE_FIELDS = '_tuple_fields';
export var SelectionProjectionComponent = function SelectionProjectionComponent() {
  _classCallCheck(this, SelectionProjectionComponent);

  for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
    items[_key] = arguments[_key];
  }

  this.items = items;
  this.has = {};
};
var project = {
  has: function has() {
    return true; // This transform handles its own defaults, so always run parse.
  },
  parse: function parse(model, selDef, selCmpt) {
    var name = selCmpt.name;
    var proj = selCmpt.project || (selCmpt.project = new SelectionProjectionComponent());
    var parsed = {};
    var timeUnits = {};
    var signals = new Set();

    var signalName = function signalName(p, range) {
      var suffix = range === 'visual' ? p.channel : p.field;
      var sg = varName("".concat(name, "_").concat(suffix));

      for (var counter = 1; signals.has(sg); counter++) {
        sg = varName("".concat(name, "_").concat(suffix, "_").concat(counter));
      }

      signals.add(sg);
      return _defineProperty({}, range, sg);
    }; // If no explicit projection (either fields or encodings) is specified, set some defaults.
    // If an initial value is set, try to infer projections.
    // Otherwise, use the default configuration.


    if (!selDef.fields && !selDef.encodings) {
      var cfg = model.config.selection[selDef.type];

      if (selDef.init) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = array(selDef.init)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var init = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = keys(init)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var key = _step2.value;

                if (isSingleDefUnitChannel(key)) {
                  (selDef.encodings || (selDef.encodings = [])).push(key);
                } else {
                  if (isIntervalSelection(selDef)) {
                    log.warn('Interval selections should be initialized using "x" and/or "y" keys.');
                    selDef.encodings = cfg.encodings;
                  } else {
                    (selDef.fields || (selDef.fields = [])).push(key);
                  }
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        selDef.encodings = cfg.encodings;
        selDef.fields = cfg.fields;
      }
    } // TODO: find a possible channel mapping for these fields.


    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = (selDef.fields || [])[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var field = _step3.value;
        var p = {
          type: 'E',
          field: field
        };
        p.signals = Object.assign({}, signalName(p, 'data'));
        proj.items.push(p);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = (selDef.encodings || [])[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var channel = _step4.value;
        var fieldDef = model.fieldDef(channel);

        if (fieldDef) {
          var _field = fieldDef.field;

          if (fieldDef.timeUnit) {
            _field = model.vgField(channel); // Construct TimeUnitComponents which will be combined into a
            // TimeUnitNode. This node may need to be inserted into the
            // dataflow if the selection is used across views that do not
            // have these time units defined.

            var component = {
              as: _field,
              field: fieldDef.field,
              timeUnit: fieldDef.timeUnit
            };
            timeUnits[hash(component)] = component;
          } // Prevent duplicate projections on the same field.
          // TODO: what if the same field is bound to multiple channels (e.g., SPLOM diag).


          if (!parsed[_field]) {
            // Determine whether the tuple will store enumerated or ranged values.
            // Interval selections store ranges for continuous scales, and enumerations otherwise.
            // Single/multi selections store ranges for binned fields, and enumerations otherwise.
            var type = 'E';

            if (selCmpt.type === 'interval') {
              var scaleType = model.getScaleComponent(channel).get('type');

              if (hasContinuousDomain(scaleType)) {
                type = 'R';
              }
            } else if (fieldDef.bin) {
              type = 'R-RE';
            }

            var _p = {
              field: _field,
              channel: channel,
              type: type
            };
            _p.signals = Object.assign({}, signalName(_p, 'data'), signalName(_p, 'visual'));
            proj.items.push(parsed[_field] = _p);
            proj.has[channel] = parsed[_field];
          }
        } else {
          log.warn(log.message.cannotProjectOnChannelWithoutField(channel));
        }
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    if (selDef.init) {
      if (scales.has(selCmpt)) {
        log.warn(log.message.NO_INIT_SCALE_BINDINGS);
      } else {
        var parseInit = function parseInit(i) {
          return proj.items.map(function (p) {
            return i[p.channel] !== undefined ? i[p.channel] : i[p.field];
          });
        };

        if (isIntervalSelection(selDef)) {
          selCmpt.init = parseInit(selDef.init);
        } else {
          var _init = isArray(selDef.init) ? selDef.init : [selDef.init];

          selCmpt.init = _init.map(parseInit);
        }
      }
    }

    if (keys(timeUnits).length) {
      proj.timeUnit = new TimeUnitNode(null, timeUnits);
    }
  },
  signals: function signals(model, selCmpt, allSignals) {
    var name = selCmpt.name + TUPLE_FIELDS;
    var hasSignal = allSignals.filter(function (s) {
      return s.name === name;
    });
    return hasSignal.length ? allSignals : allSignals.concat({
      name: name,
      value: selCmpt.project.items.map(function (proj) {
        var signals = proj.signals,
            rest = tslib_1.__rest(proj, ["signals"]);

        return rest;
      })
    });
  }
};
export default project;